import { render, staticRenderFns } from "./ServeFee.vue?vue&type=template&id=5d9750ae"
import script from "./ServeFee.vue?vue&type=script&lang=js"
export * from "./ServeFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports